import {format, parseISO} from "date-fns";

import {numberFormat, pluralize} from "@pg-mono/string-utils";

import {ILocationGenericSection, ParagraphType} from "../constants";

interface IProps {
    regionNameDeclensionWhere: string;
    offersCountReady: number;
    offersCountReadyInThreeMonths: number;
    offersCountReadyInSixMonths: number;
    offersCountReadyInOneYear: number;
    offerTypeNamePluralize: [string, string, string];
    offerTypeNameWithDeclensionOfReadyPluralize: [string, string, string];
    offersLatestConstructionDate: string | null;
}

export const getReadyOffersSectionTexts = (variables: IProps): ILocationGenericSection["paragraphs"] => {
    const getQuarterValue = (date: string) => {
        const quarter = Number(format(parseISO(date), "Q"));
        return ["I", "II", "III", "IV"][quarter - 1] || "";
    };

    const getYear = (date: string) => {
        return format(parseISO(date), "yyyy");
    };

    return [
        variables.offersCountReady > 0
            ? {
                  type: ParagraphType.TEXT,
                  text: [
                      `Obecnie deweloperzy ${variables.regionNameDeclensionWhere} oddali do użytku ${numberFormat(variables.offersCountReady)} ${pluralize(
                          variables.offerTypeNamePluralize
                      )(variables.offersCountReady)}. `,
                      variables.offersCountReadyInThreeMonths > 0 &&
                          `${numberFormat(variables.offersCountReadyInThreeMonths)} ${pluralize(variables.offerTypeNameWithDeclensionOfReadyPluralize)(
                              variables.offersCountReadyInThreeMonths
                          )} do 3 miesięcy. `,
                      variables.offersCountReadyInSixMonths > 0 &&
                          `${numberFormat(variables.offersCountReadyInSixMonths)} ${pluralize(variables.offerTypeNameWithDeclensionOfReadyPluralize)(
                              variables.offersCountReadyInSixMonths
                          )} do 6 miesięcy. `,
                      variables.offersCountReadyInOneYear > 0 &&
                          `${numberFormat(variables.offersCountReadyInOneYear)} ${pluralize(variables.offerTypeNameWithDeclensionOfReadyPluralize)(
                              variables.offersCountReadyInOneYear
                          )} do roku.`
                  ].filter(Boolean) as string[]
              }
            : {
                  type: ParagraphType.TEXT,
                  text: `Obecnie w ofercie deweloperów ${variables.regionNameDeclensionWhere} nie ma ${
                      variables.offerTypeNamePluralize[2]
                  } oddanych do użytku. ${
                      variables.offersLatestConstructionDate
                          ? `Najpóźniejszy termin oddania inwestycji ${variables.offerTypeNamePluralize[2]} do użytkowania to koniec ${getQuarterValue(
                                variables.offersLatestConstructionDate
                            )} kwartału ${getYear(variables.offersLatestConstructionDate)}.`
                          : ""
                  }`
              }
    ];
};
import {format, parseISO} from "date-fns";

import {numberFormat, pluralize} from "@pg-mono/string-utils";

import {ILocationGenericSection, ParagraphType} from "../constants";

interface IProps {
    regionNameDeclensionWhere: string;
    offersCountReady: number;
    offersCountReadyInThreeMonths: number;
    offersCountReadyInSixMonths: number;
    offersCountReadyInOneYear: number;
    offerTypeNamePluralize: [string, string, string];
    offerTypeNameWithDeclensionOfReadyPluralize: [string, string, string];
    offersLatestConstructionDate: string | null;
}

export const getReadyOffersSectionTexts = (variables: IProps): ILocationGenericSection["paragraphs"] => {
    const getQuarterValue = (date: string) => {
        const quarter = Number(format(parseISO(date), "Q"));
        return ["I", "II", "III", "IV"][quarter - 1] || "";
    };

    const getYear = (date: string) => {
        return format(parseISO(date), "yyyy");
    };

    return [
        variables.offersCountReady > 0
            ? {
                  type: ParagraphType.TEXT,
                  text: [
                      `Obecnie deweloperzy ${variables.regionNameDeclensionWhere} oddali do użytku ${numberFormat(variables.offersCountReady)} ${pluralize(
                          variables.offerTypeNamePluralize
                      )(variables.offersCountReady)}. `,
                      variables.offersCountReadyInThreeMonths > 0 &&
                          `${numberFormat(variables.offersCountReadyInThreeMonths)} ${pluralize(variables.offerTypeNameWithDeclensionOfReadyPluralize)(
                              variables.offersCountReadyInThreeMonths
                          )} do 3 miesięcy. `,
                      variables.offersCountReadyInSixMonths > 0 &&
                          `${numberFormat(variables.offersCountReadyInSixMonths)} ${pluralize(variables.offerTypeNameWithDeclensionOfReadyPluralize)(
                              variables.offersCountReadyInSixMonths
                          )} do 6 miesięcy. `,
                      variables.offersCountReadyInOneYear > 0 &&
                          `${numberFormat(variables.offersCountReadyInOneYear)} ${pluralize(variables.offerTypeNameWithDeclensionOfReadyPluralize)(
                              variables.offersCountReadyInOneYear
                          )} do roku.`
                  ].filter(Boolean) as string[]
              }
            : {
                  type: ParagraphType.TEXT,
                  text: `Obecnie w ofercie deweloperów ${variables.regionNameDeclensionWhere} nie ma ${
                      variables.offerTypeNamePluralize[2]
                  } oddanych do użytku. ${
                      variables.offersLatestConstructionDate
                          ? `Najpóźniejszy termin oddania inwestycji ${variables.offerTypeNamePluralize[2]} do użytkowania to koniec ${getQuarterValue(
                                variables.offersLatestConstructionDate
                            )} kwartału ${getYear(variables.offersLatestConstructionDate)}.`
                          : ""
                  }`
              }
    ];
};
